var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "daily-weekly-tasks" }, [
    !_vm.newerTask.length != 0 && _vm.weekTask && _vm.weekTask.length > 0
      ? _c("div", { staticClass: "weekly-bonus" }, [
          _c("div", { staticClass: "title" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("lang.mybean.weeklyBonus")))]),
            _c("i", [
              _vm._v(
                _vm._s(
                  _vm.weekTaskData.state == 2 ? _vm.weekTaskData.reward : 0
                ) +
                  "/" +
                  _vm._s(_vm.weekTaskData.reward)
              ),
            ]),
            _c("img", { attrs: { src: _vm.getMatchImg("beans"), alt: "" } }),
          ]),
          _c("div", { staticClass: "complete" }, [
            _c("div", { staticClass: "complete-time" }, [
              _c("span", [_vm._v(_vm._s(_vm.weekTaskData.title))]),
              _c("div", { staticClass: "time" }, [
                _vm._v(
                  "(" +
                    _vm._s(
                      _vm.replaceTime(
                        _vm.getWeekStartAndEnd(_vm.weekTaskData.curDay).monday
                      )
                    ) +
                    "-" +
                    _vm._s(
                      _vm.replaceTime(
                        _vm.getWeekStartAndEnd(_vm.weekTaskData.curDay).sunday
                      )
                    ) +
                    ")"
                ),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "complete-btn",
                class: {
                  completeSubmit: _vm.weekTaskData.state == 1,
                  completed: _vm.weekTaskData.state == 2,
                },
                on: {
                  click: function ($event) {
                    _vm.weekTaskData.state == 1 && _vm.handleWeekSubmit()
                  },
                },
              },
              [
                _vm.weekTaskData.state == 0 || _vm.weekTaskData.state == 1
                  ? _c("div", [
                      _vm._v(" " + _vm._s(_vm.weekTaskData.reward) + " "),
                      _c("img", {
                        attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                      }),
                    ])
                  : _vm._e(),
                _vm.weekTaskData.state == 2
                  ? _c("div", [
                      _c("img", {
                        staticClass: "arImgTran180",
                        attrs: {
                          src: require("@/assets/packageAssets/views/P1_Girls/HostessTasks/vava/check.png"),
                          alt: "",
                        },
                      }),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "day-list" },
            _vm._l(_vm.weekTaskData.weeks, function (item, index) {
              return _c("div", { key: index, staticClass: "day" }, [
                Date.parse(item.day) >= Date.parse(_vm.weekTaskData.curDay)
                  ? _c("div", { staticClass: "dayNotStartbg" }, [
                      _c("img", {
                        staticClass: "finish-icon",
                        attrs: {
                          src: require("@/assets/packageAssets/views/P1_Girls/HostessTasks/vava/notStarted_icon.png"),
                          alt: "",
                        },
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.weekList[index]))]),
                    ])
                  : _c(
                      "div",
                      {
                        staticClass: "day-bg",
                        class: { failActive: !item.ifFinished },
                      },
                      [
                        item.ifFinished
                          ? _c("img", {
                              staticClass: "finish-icon",
                              attrs: {
                                src: require("@/assets/packageAssets/views/P1_Girls/HostessTasks/vava/complete_icon.png"),
                                alt: "",
                              },
                            })
                          : _c("img", {
                              staticClass: "finish-icon",
                              attrs: {
                                src: require("@/assets/packageAssets/views/P1_Girls/HostessTasks/vava/fail_icon.png"),
                                alt: "",
                              },
                            }),
                        _c("span", [_vm._v(_vm._s(_vm.weekList[index]))]),
                      ]
                    ),
              ])
            }),
            0
          ),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "daily-tasks" },
      [
        _c("div", { staticClass: "title" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.more2")))]),
          _vm.total
            ? _c("i", { class: { lockedColor: _vm.newerTask.length > 0 } }, [
                _vm._v(
                  _vm._s(
                    _vm.newerTask.length > 0 ? "Locked" : _vm.total.reward
                  ) +
                    "/" +
                    _vm._s(_vm.total.total)
                ),
              ])
            : _vm._e(),
          _c("img", { attrs: { src: _vm.getMatchImg("beans"), alt: "" } }),
        ]),
        _vm.dailyTask && _vm.dailyTask.length > 0
          ? [
              _c(
                "div",
                { staticClass: "list-box" },
                [
                  _vm.newerTask && _vm.newerTask.length > 0
                    ? _c("div", { staticClass: "daily-task-mask" }, [
                        _c("div", { staticClass: "lock" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/packageAssets/views/P1_Girls/HostessTasks/vava/lock_flag.png"),
                              alt: "",
                            },
                          }),
                          _c("div", { staticClass: "text" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("lang.task.dailyTaskLockTip")) +
                                " "
                            ),
                            _c("i", [
                              _vm._v(
                                _vm._s(
                                  _vm.handleOneText(
                                    _vm.$t("lang.task.unlockNumFormat"),
                                    "%s",
                                    _vm.total.total
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.dailyTask, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "daily-task-list",
                        class: {
                          "glass-view": _vm.newerTask && _vm.newerTask.length,
                        },
                      },
                      [
                        _vm.bubbleShow && item.customState === 1 && index === 0
                          ? _c("div", { staticClass: "bubble-tips" }, [
                              _c("div", { staticClass: "bubble-content" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("lang.commonM.k113"))),
                                ]),
                                _c("div", { staticClass: "bubble-tran" }),
                              ]),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "left-btn-text" }, [
                          _c("span", { staticClass: "text" }, [
                            _vm._v(_vm._s(_vm.handleTitle1(item.title))),
                          ]),
                          item.conditions && item.conditions.length > 1
                            ? _c("div", { staticClass: "left-btn" }, [
                                _vm.handleStatus(item.conditions) == 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "left-btn-box arrow left-nav",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleArrow(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/packageAssets/views/P1_Girls/HostessTasks/vava/arrow.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.handleStatus(item.conditions) == 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "left-btn-box success left-nav",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRward(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("lang.commonM.k073"))
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.handleStatus(item.conditions) == 2
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "left-btn-box checked left-nav",
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/packageAssets/views/P1_Girls/HostessTasks/vava/check.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _c("div", { staticClass: "left-btn" }, [
                                item.conditions[0].state == 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "left-btn-box arrow left-nav",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleArrow(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/packageAssets/views/P1_Girls/HostessTasks/vava/arrow.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                item.conditions[0].state == 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "left-btn-box success left-nav",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRward(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("lang.commonM.k073"))
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                item.conditions[0].state == 2
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "left-btn-box checked left-nav",
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "arImgTran180",
                                          attrs: {
                                            src: require("@/assets/packageAssets/views/P1_Girls/HostessTasks/vava/check.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                        ]),
                        _c("div", { staticClass: "time-num-money" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.handleTitle2(item.title))),
                          ]),
                          item.conditions && item.conditions.length == 1
                            ? _c("div", { staticClass: "btn-num" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.conditions[0].rewardList[0]
                                        .rewardPropNum
                                    ) +
                                    " "
                                ),
                                _c("img", {
                                  attrs: {
                                    src: _vm.getMatchImg("beans"),
                                    alt: "",
                                  },
                                }),
                              ])
                            : _vm._e(),
                        ]),
                        item.conditions && item.conditions.length > 1
                          ? _c("div", { staticClass: "progress-three" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "progress-line ar-rogress-line",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "node" },
                                    [
                                      _c("div", {
                                        staticClass: "node-item",
                                        class: {
                                          arNodeItem: _vm.$i18n.locale == "ar",
                                        },
                                      }),
                                      _vm._l(
                                        item.conditions,
                                        function (child, index) {
                                          return [
                                            _vm.$i18n.locale != "ar"
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass: "node-item",
                                                      class: {
                                                        arNodeItem:
                                                          _vm.$i18n.locale ==
                                                          "ar",
                                                        taskSuccess:
                                                          child.state == 2,
                                                        checked:
                                                          child.state == 1,
                                                      },
                                                      style: {
                                                        left: `${
                                                          child.goal /
                                                          _vm.handleComputeNodeValue(
                                                            item.conditions
                                                          )
                                                        }%`,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "node-top",
                                                        },
                                                        [
                                                          _c("div", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  child
                                                                    .rewardList[0]
                                                                    .rewardPropNum
                                                                ) +
                                                                " "
                                                            ),
                                                            _c("img", {
                                                              attrs: {
                                                                src: _vm.getMatchImg(
                                                                  "beans"
                                                                ),
                                                                alt: "",
                                                              },
                                                            }),
                                                          ]),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "node-bottom",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                child.goalDisplay
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : [
                                                  _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass: "node-item",
                                                      class: {
                                                        arNodeItem:
                                                          _vm.$i18n.locale ==
                                                          "ar",
                                                        taskSuccess:
                                                          child.state == 2,
                                                        checked:
                                                          child.state == 1,
                                                      },
                                                      style: {
                                                        right: `${
                                                          child.goal /
                                                          _vm.handleComputeNodeValue(
                                                            item.conditions
                                                          )
                                                        }%`,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "node-top",
                                                        },
                                                        [
                                                          _c("div", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  child
                                                                    .rewardList[0]
                                                                    .rewardPropNum
                                                                ) +
                                                                " "
                                                            ),
                                                            _c("img", {
                                                              attrs: {
                                                                src: _vm.getMatchImg(
                                                                  "beans"
                                                                ),
                                                                alt: "",
                                                              },
                                                            }),
                                                          ]),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "node-bottom",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                child.goalDisplay
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _c("van-progress", {
                                    staticClass: "progress-bar",
                                    class: {
                                      arProgressBar: _vm.$i18n.locale == "ar",
                                    },
                                    attrs: {
                                      "track-color": "#ffffff",
                                      "show-pivot": true,
                                      "pivot-text": _vm.threeMaxProc(
                                        item.conditions
                                      ),
                                      percentage: _vm.handleComputeProgress(
                                        item.conditions
                                      ),
                                      "stroke-width": "4",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        item.conditions && item.conditions.length == 1
                          ? _c(
                              "div",
                              { staticClass: "online-call ar-online-call" },
                              [
                                item.conditions[0].targetOnlineTimeRangeSeconds
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "progress-bar-box progress-bar-box-online",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("lang.task.online"))
                                          ),
                                        ]),
                                        _c("van-progress", {
                                          staticClass: "progress-bar",
                                          class: {
                                            arProgressBar:
                                              _vm.$i18n.locale == "ar",
                                          },
                                          attrs: {
                                            "track-color": "#ffffff",
                                            "show-pivot": true,
                                            "pivot-text": _vm.onlineProc(
                                              item.conditions[0]
                                                .onlineTimeRangeSeconds
                                            ),
                                            percentage:
                                              _vm.handlePercentageOnlineCall(
                                                item.conditions[0]
                                                  .onlineTimeRangeSeconds,
                                                item.conditions[0]
                                                  .targetOnlineTimeRangeSeconds
                                              ),
                                            "stroke-width": "4",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "state-number" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "state-number-box",
                                                class: {
                                                  arStateNumberBox:
                                                    _vm.$i18n.locale == "ar",
                                                  arStateNumberSuccess:
                                                    _vm.$i18n.locale == "ar",
                                                  stateNumberSuccess:
                                                    _vm.handlePercentageOnlineCall(
                                                      item.conditions[0]
                                                        .onlineTimeRangeSeconds,
                                                      item.conditions[0]
                                                        .targetOnlineTimeRangeSeconds
                                                    ) >= 100,
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.handleSecondsHours(
                                                        item.conditions[0]
                                                          .targetOnlineTimeRangeSeconds
                                                      )
                                                    ) +
                                                      _vm._s(
                                                        _vm.$t("lang.task.hrs")
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                item.conditions[0].targetCallTimeRangeSeconds
                                  ? _c(
                                      "div",
                                      { staticClass: "progress-bar-box" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "lang.earnRule.callDuration"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("van-progress", {
                                          staticClass: "progress-bar",
                                          class: {
                                            arProgressBar:
                                              _vm.$i18n.locale == "ar",
                                          },
                                          attrs: {
                                            "track-color": "#ffffff",
                                            "show-pivot": true,
                                            "pivot-text": _vm.callProc(
                                              item.conditions[0]
                                                .callTimeRangeSeconds
                                            ),
                                            percentage:
                                              _vm.handlePercentageOnlineCall(
                                                item.conditions[0]
                                                  .callTimeRangeSeconds,
                                                item.conditions[0]
                                                  .targetCallTimeRangeSeconds
                                              ),
                                            "stroke-width": "4",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "state-number" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "state-number-box",
                                                class: {
                                                  arStateNumberBox:
                                                    _vm.$i18n.locale == "ar",
                                                  arStateNumberSuccess:
                                                    _vm.$i18n.locale == "ar",
                                                  stateNumberSuccess:
                                                    _vm.handlePercentageOnlineCall(
                                                      item.conditions[0]
                                                        .callTimeRangeSeconds,
                                                      item.conditions[0]
                                                        .targetCallTimeRangeSeconds
                                                    ) >= 100,
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.handleSecondsMinutes(
                                                        item.conditions[0]
                                                          .targetCallTimeRangeSeconds
                                                      )
                                                    ) +
                                                      _vm._s(
                                                        _vm.$t("lang.task.mins")
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !item.conditions[0].targetCallTimeRangeSeconds
                                  ? _c(
                                      "div",
                                      { staticClass: "progress-bar-box" },
                                      [
                                        _c("van-progress", {
                                          staticClass: "progress-bar",
                                          class: {
                                            arProgressBar:
                                              _vm.$i18n.locale == "ar",
                                          },
                                          attrs: {
                                            "track-color": "#ffffff",
                                            "show-pivot": true,
                                            "pivot-text": _vm.threeMaxProc(
                                              item.conditions
                                            ),
                                            percentage:
                                              (item.conditions[0].proc /
                                                item.conditions[0].goal) *
                                              100,
                                            "stroke-width": "4",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "state-number" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "state-number-box",
                                                class: {
                                                  arStateNumberBox:
                                                    _vm.$i18n.locale == "ar",
                                                  arStateNumberSuccess:
                                                    _vm.$i18n.locale == "ar",
                                                  stateNumberSuccess:
                                                    item.conditions[0].goal ==
                                                    item.conditions[0].proc,
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.conditions[0]
                                                        .goalDisplay
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]
          : _vm._e(),
        _c(
          "van-popup",
          {
            staticClass: "van-popup-box",
            attrs: { "lock-scroll": false },
            on: { close: _vm.closeShowRewardDia },
            model: {
              value: _vm.showRewardDia,
              callback: function ($$v) {
                _vm.showRewardDia = $$v
              },
              expression: "showRewardDia",
            },
          },
          [
            _c("div", { staticClass: "reward-dia" }, [
              _c("img", {
                staticClass: "bulibuli",
                attrs: { src: _vm.getMatchImg("reward-bg"), alt: "" },
              }),
              _c("span", { staticClass: "number" }, [
                _vm._v("x" + _vm._s(_vm.rewardNumber)),
              ]),
            ]),
            _c("div", { staticClass: "reward-dia-btn" }, [
              _c("span", { on: { click: _vm.handleRewardDiaConfirm } }, [
                _vm._v(_vm._s(_vm.$t("lang.confirm"))),
              ]),
            ]),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }